import React from 'react';
import { RotatingLines, ThreeDots } from 'react-loader-spinner'

export const PageLoader = ({ color, width }) => {
    return (
        <>
            <div className="loaderScreen py-2">
                <RotatingLines
                    strokeColor={color}
                    strokeWidth="5"
                    animationDuration="0.5"
                    width={width}
                    visible={true}
                />
            </div>
        </>
    )
}

export const PageLoaderDots = ({ color, width, padding = 2 }) => {
    return (
        <>
            <div className={`loaderScreen py-${padding}`}>
                <ThreeDots
                    visible={true}
                    height={width}
                    width={width}
                    color={color}
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
            </div>
        </>
    )
}